// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e1UI","footer":"styles_footer__2cMIX","passCodeTooltip":"styles_passCodeTooltip__3oTJ-"};